/**
 * 管理端接口前缀：{origin}/adminapi
 *
 * 开发环境（npm run serve）：
 *   默认使用 VUE_APP_ADMIN_API_ORIGIN 的完整地址（浏览器 Network 里即为该域名），
 *   例如 http://calorietools.com/adminapi 。
 *   若需改为「请求发到当前 dev 域名 + 由 proxy 转发」，在 .env.development 设置：
 *   VUE_APP_ADMIN_API_USE_PROXY=true
 *
 * 生产环境：
 *   VUE_APP_ADMIN_API_ORIGIN 有值则用该域名；否则用 window.location.origin 。
 */

function normalizeOrigin(raw) {
  if (raw == null || !String(raw).trim()) return ''
  let s = String(raw).trim().replace(/\/$/, '')
  if (!/^https?:\/\//i.test(s)) {
    s = `http://${s}`
  }
  return s
}

export function getAdminApiBase() {
  const fromEnv = normalizeOrigin(process.env.VUE_APP_ADMIN_API_ORIGIN)
  const useProxy =
    process.env.NODE_ENV === 'development' &&
    process.env.VUE_APP_ADMIN_API_USE_PROXY === 'true'

  if (useProxy) {
    return '/adminapi'
  }

  if (process.env.NODE_ENV === 'development') {
    const origin = fromEnv || normalizeOrigin('calorietools.com')
    return `${origin}/adminapi`
  }

  const origin = fromEnv || normalizeOrigin(window.location.origin)
  return `${origin}/adminapi`
}
